// Storefront category product list views. Labels and descriptions are English
// translation keys; they are listed in backend/gettext/pos-strings.c.
export const productListViews = [
  {
    value: 'default',
    label: 'Product grid',
    description: 'Products as cards in a grid with image, title and price.'
  },
  {
    value: 'list',
    label: 'List view',
    description: 'Compact rows with a thumbnail, title and short description.'
  },
  {
    value: 'listdate',
    label: 'Date-sorted list',
    description: 'List view ordered by published date, newest first. The action button shows the rest.'
  },
  {
    value: 'listpreview',
    label: 'List with preview',
    description: 'List rows that open the product in a preview window.'
  },
  {
    value: 'listpreviewdate',
    label: 'Date-sorted list with preview',
    description: 'List with preview ordered by published date, newest first. The action button shows the rest.'
  },
  {
    value: 'horizontalcard',
    label: 'Horizontal card list',
    description: 'List cards with a square image on the left and the content beside it.'
  },
  {
    value: 'horizontalcardpreview',
    label: 'Horizontal card list with preview',
    description: 'Horizontal cards that open the product in a preview window.'
  },
  {
    value: 'horizontalcardpreviewdate',
    label: 'Date-sorted horizontal card list with preview',
    description: 'Horizontal card list with preview ordered by published date, newest first. The action button shows the rest.'
  },
  {
    value: 'imagerows',
    label: 'Image and description in one row',
    description: 'A large image with the description beside it, one product per row.'
  },
  {
    value: 'showtimes',
    label: 'Showtimes',
    description: 'Upcoming shows of the events in the category.'
  },
  {
    value: 'availabilitylist',
    label: 'Availability search',
    description: 'Date and filter search above the product list.'
  },
  {
    value: 'fulltextsearch',
    label: 'Full-text search',
    description: 'Text search field above the product list.'
  },
  {
    value: 'availabilityfulltext',
    label: 'Combined availability and full-text search',
    description: 'Availability and text search together above the product list.'
  }
]

export const isDateSortedView = (view) => view === 'listdate' || view === 'listpreviewdate' || view === 'horizontalcardpreviewdate'

export const findProductListView = (view) => productListViews.find(v => v.value === view)

export const viewLabel = (view, _) => {
  const translate = typeof _ === 'function' ? _ : (s) => s
  const option = findProductListView(view)
  return option ? translate(option.label) : String(view || '')
}
